import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { OpportunitiesSearchParams, SuppliersSearchParams } from 'app/shared/objects/suppliers';
import { TypesOnSolutionHelper } from 'app/shared/objects/solutions';
import { CitiesPainelSearch } from 'app/painel/services/painel-cities.service';

import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';


import { SmartCitiesHelper } from 'app/shared/objects/cities';

@Injectable()
export class SuppliersService {

  constructor(private http: HttpClient) {
  }

  getSupplier(id: string) {
    return this.http.get(environment.apiURL + '/restricted/supplier/solutionTranslate/' + id)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  public async getExcelFile(filter: OpportunitiesSearchParams): Promise<ArrayBuffer> {
    const file$ = this.http.post(environment.apiURL + '/restricted/supplier/opportunities/export', filter, { responseType: 'arraybuffer' })

    return await file$.toPromise()
      .then((res) => {
        return res;
      })
      .catch((err) => {
        throw new HttpErrorResponse(err)
      })
  }

  postSupplier(data: any) {
    return this.http.post(environment.apiURL + '/restricted/supplier', data)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  postSupplierTranslation(data: any, lang: string) {
    return this.http.post(environment.apiURL + '/restricted/supplier/supplierLanguage/' + lang, data)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getSolutions(supplierId: string) {
    return this.http.get(environment.apiURL + '/restricted/supplier/solutions/' + supplierId)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  postSolution(data: any) {
    return this.http.post(environment.apiURL + '/restricted/supplier/solution', data)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  postSolutionTranslation(data: any, lang: string) {
    return this.http.post(environment.apiURL + '/restricted/supplier/solutionLanguage/' + lang, data)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getTypeSolution(): Promise<TypesOnSolutionHelper> {
    return this.http.get(environment.apiURL + '/restricted/supplier/typesOnSolution')
      .toPromise()
      .then(response => {
        return response as TypesOnSolutionHelper;
      })
      .catch(error => {
        return null;
      });
  }

  getOpportunities(params: OpportunitiesSearchParams) {
    return this.http.post(environment.apiURL + '/restricted/supplier/opportunities', params)
      .toPromise()
      .then(response => {
        return response;
      })
      .catch(error => {
        return null;
      });
  }

  searchLocation(terms: Observable<string>) {
    return terms.pipe(debounceTime(400),
      distinctUntilChanged(),
      switchMap(term => this.getLocationResult(term)),);
  }

  getLocationResult(search: string) {
    var params = new CitiesPainelSearch();

    params.completenessRange.min = 0;
    params.completenessRange.max = 500;
    params.pageControl.limit = 500;
    params.searchQuery = search;

    return this.http.post(environment.apiURL + '/restricted/supplier/availablePlaces', params);
  }

  getSearchSmartCities(search: string): Promise<SmartCitiesHelper[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/searchCity/' + search)
      .toPromise()
      .then(response => {
        return response as SmartCitiesHelper[];
      })
      .catch(error => {
        return null;
      });
  }

  //LEGADO
  getSuppliers(params: SuppliersSearchParams) {
    return this.http.post(environment.apiURL + '/frontEndOpen/citiesSuppliersPaginated', params)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getFilters() {
    return this.http.get(environment.apiURL + '/frontEndOpen/suppliersList')
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

  getSupplierSingle(id: string) {
    return this.http.get(environment.apiURL + '/restricted/supplier/profile/' + id)
      .toPromise()
      .then(response => response)
      .catch(error => {
        return null;
      });
  }

}
